<script setup lang="ts">
// Corps d'un aperçu carte : annonce de chargement (sr-only), skeleton (slot #loading surchargeable),
// message d'erreur, sinon le contenu (slot par défaut). Factorisé car WebMapPopup le rend à deux
// endroits selon le format : feuille mobile (AppMapSheet) et en-tête du panneau flottant desktop.
defineProps<{ loading?: boolean; error?: string }>();
</script>

<template>
  <p role="status" class="sr-only">
    <template v-if="loading">{{ $t("ui.loading") }}</template>
  </p>
  <div v-if="loading" aria-hidden="true">
    <slot name="loading">
      <div class="space-y-4 py-1">
        <USkeleton class="h-5.5 w-full max-w-60" />
        <USkeleton class="h-4.5 w-3/4" />
      </div>
    </slot>
  </div>
  <p v-else-if="error" class="text-error text-sm/tight">{{ error }}</p>
  <slot v-else />
</template>
